import { atom } from "nanostores"
import { persistentAtom } from "@nanostores/persistent"

export const $isMyLeadsRunning = atom<boolean>(false)

export const setIsMyLeadsRunning = (
  isRunning: boolean,
  timeout: number = 300
) => {
  $isMyLeadsRunning.set(isRunning)
  if (isRunning) {
    setTimeout(() => {
      $isMyLeadsRunning.set(false)
    }, timeout * 1000)
  }
}

// Persistent atom for widget view count
export const $propertiesWidgetViewCount = persistentAtom<number>(
  "propertiesWidgetViewCount",
  0,
  { encode: JSON.stringify, decode: JSON.parse }
)

// Function to increment the widget view count
export const incrementWidgetViewCount = () => {
  const currentCount = $propertiesWidgetViewCount.get() || 0
  const newCount = currentCount + 1
  $propertiesWidgetViewCount.set(newCount)
}

// Function to reset the widget view count
export const resetPropertiesWidgetCount = () => {
  $propertiesWidgetViewCount.set(0)
}

// Buy Box

// Persistent Atom for Buy Box Setup State
// Tracks if a save on Buy Box has occurred
export const $isBuyBoxSetUp = persistentAtom<boolean>("isBuyBoxSetUp", false, {
  encode: JSON.stringify,
  decode: JSON.parse,
})

// Function to set Buy Box Setup
export const setBuyBoxSetUp = (isSetUp: boolean) => {
  $isBuyBoxSetUp.set(isSetUp)
}

// Function to reset the Buy Box setup state
export const resetBuyBoxSetup = () => {
  $isBuyBoxSetUp.set(false)
}
